var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndGameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9064 0H5.06414C2.26709 0 0 2.26709 0 5.06414V22.9359C0 25.7329 2.26709 28 5.06414 28H22.9359C25.7329 28 28 25.7329 28 22.9359V5.06414C27.9706 2.26709 25.7035 0 22.9064 0ZM12.6604 6.18297C12.6604 5.4469 13.2492 4.85804 13.9853 4.85804C14.7213 4.85804 15.3102 5.4469 15.3102 6.18297V12.9253C15.3102 13.6614 14.7213 14.2503 13.9853 14.2503C13.2492 14.2503 12.6604 13.6614 12.6604 12.9253V6.18297ZM13.9853 23.142C9.21556 23.142 5.32913 19.2555 5.32913 14.4858C5.32913 11.7476 6.59516 9.245 8.77392 7.59621C9.36278 7.15457 10.2166 7.27235 10.6583 7.8612C11.0999 8.45005 10.9821 9.30389 10.3933 9.74553C8.89169 10.8938 8.00841 12.6015 8.00841 14.4858C8.00841 17.7834 10.6877 20.4627 13.9853 20.4627C17.2829 20.4627 19.9621 17.7834 19.9621 14.4858C19.9621 12.6015 19.1083 10.8644 17.5773 9.74553C16.9884 9.30389 16.8707 8.45005 17.3123 7.8612C17.7539 7.27235 18.6078 7.15457 19.1966 7.59621C21.3754 9.245 22.6414 11.7476 22.6414 14.4858C22.6414 19.2555 18.755 23.142 13.9853 23.142Z",
    fill: "#D23333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndGameIcon);
export default __webpack_public_path__ + "static/media/endGameIcon.8ff5963c0ae252205547819acf1c6458.svg";
export { ForwardRef as ReactComponent };